import {
  disputeReason,
  disputeStatus,
  disputeViewSchema,
} from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeStatus)).optional(),
    reasons: z.array(z.enum(disputeReason)).optional(),
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
  }),
  output: z.object({
    disputes: z.array(disputeViewSchema),
    total: z.number().int(),
  }),
};
